export const GET_TICKET_STATES = "GET_TICKET_STATES";
export const RESOLVE_TICKET_STATES = 'RESOLVE_TICKET_STATES'
